import { Pipe, PipeTransform } from '@angular/core';
import '@angular/localize/init';
import { AUTHENTICATION_ERROR_MESSAGES } from '@epicuro-next/constants/features/localization';

@Pipe({
  name: 'translatePasswordValidations',
})
export class TranslatePasswordValidationsPipe implements PipeTransform {
  public transform(value: string): string {
    return AUTHENTICATION_ERROR_MESSAGES[value] || value;
  }
}
